export default "__VITE_ASSET__CZRqcEmb__"